const defaultStyles = {
  noBorder: {
    "& .MuiOutlinedInput-root": {
      height: 20,
      "& fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
    },
    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  root: {
    "&.MuiOutlinedInput-root": {
      borderRadius: 2,
    },
    "& .MuiOutlinedInput-input": {
      color: "green.dark",
      backgroundColor: "white",
      borderRadius: 4,
    },
    "& .MuiSelect-select": {
      minHeight: "auto",
    },
    fontSize: { xs: 12, md: 14 },
  },
};

export default defaultStyles;
